import { render, staticRenderFns } from "./DefaultStamp.vue?vue&type=template&id=368a322c&scoped=true&functional=true&"
import script from "./DefaultStamp.vue?vue&type=script&lang=js&"
export * from "./DefaultStamp.vue?vue&type=script&lang=js&"
import style0 from "./DefaultStamp.vue?vue&type=style&index=0&id=368a322c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "368a322c",
  null
  
)

export default component.exports